import { useCustomDomain } from './useCustomDomain'

const SLICE_LENGTH: Record<
  'character' | 'guild' | 'community' | 'team',
  number
> = {
  character: 5, // /character/:region/:realm/:character
  guild: 5, // /guild/:region/:realm/:guild
  community: 3, // /community/:community
  team: 7, // /<guild|community>/:region/:realm/:guild/teams/:team
}

const useBasePath = (scope: keyof typeof SLICE_LENGTH) => {
  const { customDomain } = useCustomDomain()
  const pathSegments = window.location.pathname.split('/')
  const isGuildCustomDomainTeamPath =
    scope === 'team' &&
    customDomain?.guild &&
    !customDomain.team &&
    pathSegments[1] === 'teams' &&
    pathSegments[2]

  if (isGuildCustomDomainTeamPath) {
    return pathSegments.slice(0, 3).join('/')
  }

  return pathSegments.length >= SLICE_LENGTH[scope]
    ? pathSegments.slice(0, SLICE_LENGTH[scope]).join('/')
    : undefined
}

export default useBasePath
